<div class="w-100 h-100 d-flex align-items-center justify-content-center" >
    <div *ngIf="isCategory" [ngClass]="{'skelton': !categoryInfo}" class="text-center" style="position: relative;">
        <img *ngIf="categoryInfo.info.badge != 'None'" class="anim-bg" src="assets/icons/confeti.gif" alt="">
        <div class="img-container mb-4">
            <img width="100" [src]="categoryInfo.image" alt="">
            <img *ngIf="categoryInfo.info.badge == 'None'" width="45" class="img-badge" src="assets/icons/no-badge.svg" alt="no-badge">
            <img *ngIf="categoryInfo.info.badge == 'Bronze'" width="45" class="img-badge" src="assets/icons/bronze-badge.svg" alt="no-badge">
            <img *ngIf="categoryInfo.info.badge == 'Silver'" width="45" class="img-badge" src="assets/icons/silver-badge.svg" alt="no-badge">
            <img *ngIf="categoryInfo.info.badge == 'Gold'" width="45" class="img-badge" src="assets/icons/gold-badge.svg" alt="no-badge">
        </div>
        <p *ngIf="categoryInfo.info.badge == 'None'" class="text-32-600-125">{{'No badge'| translate}}</p>
        <p *ngIf="categoryInfo.info.badge == 'Bronze'" class="c-bronze text-32-600-125">{{'Bronze badge'| translate}}</p>
        <p *ngIf="categoryInfo.info.badge == 'Silver'" class="c-silver text-32-600-125">{{'Silver badge'| translate}}</p>
        <p *ngIf="categoryInfo.info.badge == 'Gold'" class="c-gold text-32-600-125">{{'Gold badge'| translate}}</p>
        <div class="d-flex justify-content-center">
            <p *ngIf="categoryInfo.info.badge != 'None'" class="w-75 text-center mb-4 text-40-600-130 text-c4">
                {{"You've successfully completed this topic!" | translate}}
            </p>
        </div>
        <p *ngIf="categoryInfo.info.badge != 'None'" class="text-c2 text-14-400-157">
            {{"You proved yourself you're a genie for this topic" | translate}}
                <br>
            {{'Keep up the good work!' | translate}}</p>
        <p class="mt-4 mb-5">
            <span class="score-container text-16-500-168 text-c2">
                {{'Score'|translate}}: {{categoryInfo.info.score}}/{{categoryInfo.info.maximum_score}}
            </span>
        </p>
        <button (click)="goToNextTopic()" class="text-16-500-125 next-topic-btn">{{categoryInfo.info.is_completed ? ('Go to map view' | translate) : ('Play next topic' | translate)}}</button>
    </div>
    <div *ngIf="!isCategory" [ngClass]="{'skelton': !countryInfo}" class="text-center" style="position: relative;">
        <img *ngIf="countryInfo.info.badge != 'None'" class="anim-bg" src="assets/icons/confeti.gif" alt="">
        <div class="img-container mb-4">
            <img width="100" [src]="countryInfo.flag" alt="">
            <img *ngIf="countryInfo.info.badge == 'None'" width="45" class="img-badge" src="assets/icons/no-badge.svg" alt="no-badge">
            <img *ngIf="countryInfo.info.badge == 'Bronze'" width="45" class="img-badge" src="assets/icons/bronze-badge.svg" alt="no-badge">
            <img *ngIf="countryInfo.info.badge == 'Silver'" width="45" class="img-badge" src="assets/icons/silver-badge.svg" alt="no-badge">
            <img *ngIf="countryInfo.info.badge == 'Gold'" width="45" class="img-badge" src="assets/icons/gold-badge.svg" alt="no-badge">
        </div>
        <p *ngIf="countryInfo.info.badge == 'None'" class="text-32-600-125">{{'No badge'| translate}}</p>
        <p *ngIf="countryInfo.info.badge == 'Bronze'" class="c-bronze text-32-600-125">{{'Bronze badge'| translate}}</p>
        <p *ngIf="countryInfo.info.badge == 'Silver'" class="c-silver text-32-600-125">{{'Silver badge'| translate}}</p>
        <p *ngIf="countryInfo.info.badge == 'Gold'" class="c-gold text-32-600-125">{{'Gold badge'| translate}}</p>
        <div class="d-flex justify-content-center">
            <p *ngIf="countryInfo.info.badge != 'None'" class="w-75 text-center mb-4 text-40-600-130 text-c4">
                {{"You've successfully completed this topic!" | translate}}
            </p>
        </div>
        <p *ngIf="countryInfo.info.badge != 'None'" class="text-c2 text-14-400-157">
            {{"You proved yourself you're a genie for this topic"| translate}}
                <br>
            {{'Keep up the good work!' | translate}}</p>
        <p class="mt-4 mb-5">
            <span class="score-container text-16-500-168 text-c2">
                {{'Score'|translate}}: {{countryInfo.info.score}}/{{countryInfo.info.maximum_score}}
            </span>
        </p>
        <button (click)="goToNextTopic()" class="text-16-500-125 next-topic-btn">{{countryInfo.info.is_completed ? ('Go to map view' | translate) : ('Play next topic' | translate)}}</button>
    </div>
</div>
